module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/nodejs/version/version.component.less
// module id = 1206
// module chunks = 1